module.exports = __webpack_public_path__ + "img/夏广.52941816.jpg";